import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Empty } from "antd";
// import { CustomBarChart } from "../../../common/components/dashboard";

class RegisteredDeviceCountView extends React.Component {
  render() {
    return (
      <>
        <div className="p5-form-container">
          <Row className="text-center" justify="space-around" align="middle">
            <Col span={24}>
              <div>
                <h1 className="p5-dash-h1-header text-center">{this.props.title}</h1>
              </div>
            </Col>
          </Row> 
          <br />
          {
            this.props.data.length === 0 ? (
              <>
                <Empty />
              </>
              ) : (
                <Row key="activated-dvices" justify="space-around" align="middle">
                  {
                    this.props.data.map((device) => (
                      <Col span={12}>
                        <div>
                          <h1 className="p5-dash-h1-header text-center">
                            <span className="dash-percent-value">
                              {device.AllocatedCount}
                            </span>
                          </h1>
                        </div>
                        <div>
                          <h1 className="p5-dash-h1-header text-center">
                            <span>
                              {device.AreaName}
                            </span>
                          </h1>
                        </div>                        
                      </Col>
                    ))
                    }
                </Row>  
              )
          }          
        </div>
      </>
    );
  }
}

RegisteredDeviceCountView.propTypes = {
//   loading: PropTypes.bool,
  title: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({})),
};

RegisteredDeviceCountView.defaultProps = {
//   loading: false,
  title: "",
  data: [],
};

export { RegisteredDeviceCountView as default };
